// extracted by mini-css-extract-plugin
module.exports = {"cardHeaderDefaultColor":"#75f0ce"};